import React from 'react';
import { Card, Title, Text, Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell } from '@tremor/react';
import { TableData } from '../../utils/blogTypes';

interface BlogTableProps {
  tableData: TableData;
}

export default function BlogTable({ tableData }: BlogTableProps) {
  const { title, description, headers, rows } = tableData;

  return (
    <Card className="my-6 bg-white border border-gray-200 shadow-sm hover:shadow-md transition-shadow rounded-lg">
      <Title className="text-gray-900">{title}</Title>
      {description && <Text className="text-gray-700 mt-2">{description}</Text>}
      <Table className="mt-4">
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableHeaderCell key={index} className="text-blue-800 bg-blue-50 font-semibold">
                {header}
              </TableHeaderCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              {Object.values(row).map((cell, cellIndex) => (
                <TableCell key={cellIndex} className="text-gray-700">
                  {cell as React.ReactNode}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
